import { useMutation } from "@apollo/client/react";
import { GetShiftInstanceByRange } from "hooks/apollo/shiftInstance/shiftInstance.gql";
import { removeWorkBlocksForWorkOrder } from "hooks/apollo/workBlock/helpers/handleUpdateWorkBlocks";
import { useSchedulerState } from "hooks/state";
import useTimeZone from "hooks/useTimeZone";
import { removeWorkOrder } from "./helpers/handleUpdateWorkOrders";
import { DeleteWorkOrder } from "./workOrder.gql";

export default function useDeleteWorkOrder(props) {
  const {
    state: { dataTimeRange },
  } = useSchedulerState();
  const [deleteWorkOrder] = useMutation(DeleteWorkOrder, props);
  const { overrideToSiteTimeZone } = useTimeZone();

  return ({ workOrderId }) => {
    const start = overrideToSiteTimeZone(dataTimeRange.startDate);
    const end = overrideToSiteTimeZone(dataTimeRange.endDate);

    return deleteWorkOrder({
      refetchQueries: [
        {
          query: GetShiftInstanceByRange,
          variables: {
            scheduledEnd: end,
            scheduledStart: start,
          },
        },
      ],
      update: (proxy) => {
        const getAllBlocksVariables = {
          endsAt: end,
          startsAt: start,
        };
        removeWorkBlocksForWorkOrder(workOrderId, proxy, getAllBlocksVariables);
        removeWorkOrder(workOrderId, proxy);
      },
      variables: {
        id: workOrderId,
      },
    });
  };
}
